<input
  type="text"
  matInput
  [matAutocomplete]="auto"
  [formControl]="formControl"
  (keyup)="onFilterChange($event)"
  #inputEl
  />

<mat-autocomplete
  #auto="matAutocomplete"
  autoActiveFirstOption
  (optionSelected)="onSelected($event)"
  [displayWith]="getOptionDisplayText"
  >
  @for (option of filteredOptions; track option) {
    <mat-option [value]="option">
      {{ option?.getDisplayText() }}
    </mat-option>
  }
</mat-autocomplete>
